<template>
    <Card :title="$t('labels.order')">
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-4">
                            <FormGroup :label="$t('labels.status')">
                                <Input :model-value="order?.status?.name" :disabled="true"/>
                            </FormGroup>
                        </div>
                        <div class="col-4">
                            <FormGroup :label="$t('labels.source_id')">
                                <Input :model-value="order?.source_id" readonly/>
                            </FormGroup>
                        </div>
                        <div class="col-4">
                            <FormGroup :label="$t('labels.source_number')">
                                <Input :model-value="order?.source_number" readonly/>
                            </FormGroup>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <span class="d-flex justify-content-center" v-if="!jsonDump">
                        <Button size="sm" color="indigo d-block" @click="fetchJsonDump"  :disabled="loading">
                            <i :class="['icon-spinner4 mr-2', loading ? 'spinner': '']"></i>
                            {{ $t('buttons.fetch_json_structure') }}
                        </Button>
                    </span>
                    <JsonViewer v-else :model-value="jsonDump" height="800px"/>
                </div>
            </div>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../components/new/form/Input.vue";
import InputTextArea from "../../../../components/new/form/InputTextArea.vue";
import Button from "../../../../components/new/button/AppButton.vue";
import JsonViewer from '../../../components/viewer/JsonViewer.vue';

import { httpClient } from "../../../../services/HttpClient";

export default {
    name: "EditOrderCard",
    components: {
        Card, FormGroup, Input, InputTextArea, Button, JsonViewer
    },
    props: {
        integration: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            order: null,
            jsonDump: null,
            loading: false,
        }
    },
    methods: {
        fetchOrder() {
            httpClient.get(`/integrations/${this.integration.uuid}/orders/${this.$route.params.orderUuid}`).then((response) => {
                this.order = response.data.data
            })
        },
        fetchJsonDump() {
            this.loading = true
            httpClient.get(`/integrations/${this.integration.uuid}/orders/${this.$route.params.orderUuid}/json-dump`)
                .then((response) => {
                    this.jsonDump = response.data.data
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
        },
    },
    mounted() {
        this.fetchOrder()
    }
}
</script>